import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col } from 'antd';
import isEmpty from 'lodash/isEmpty';

import { IMG_PERSON } from '../../../../../../data/assets/img';
import { CHAT_LIST_TYPE } from '../../../../../../data/config/constants';

import { getClientProfileDetails, getActiveChatSessionId } from '../../../../../../data/redux/chats_details/selectors';
import { updateCustumAgentNoteFormInChats, getJoinedRoomUserProfile } from '../../../../../../data/redux/chats_details/actions';

import ProfileCard from '../../../../components/profilecard';
import ShowMessage from '../../../../../../components/showmessage';

class ClientProfile extends React.PureComponent {
  submitCustumAgentNoteForm = (form, callback) => {
    const { actions } = this.props;
    const { selected_active_chat_id, selected_active_chat_type, active_chat_session_id, profile_details } = this.props;
    if (selected_active_chat_id) {
      const payload = {
        sessionId: active_chat_session_id,
        customAgentNotes: {},
      };
      form.forEach(item => {
        payload.customAgentNotes[item.name] = item.value;
      });
      const data = {
        changed_value: {
          customAgentNotes: {
            ...profile_details.customAgentNotes,
            form
          }
        }
      };
      if (selected_active_chat_type === CHAT_LIST_TYPE.UNTAGGED_CHATS)
        data.sessionId = selected_active_chat_id
      else
        data.psid = selected_active_chat_id
      actions.updateCustumAgentNoteFormInChats(payload, data, callback);
    }
  }

  handleButtonClick = () => {
    const { actions, selected_active_chat_id } = this.props
    if (selected_active_chat_id)
      actions.getJoinedRoomUserProfile({ clientPsid: selected_active_chat_id })
  }

  render() {
    const { screen_width, profile_details, navigateTo, selected_active_chat_id, loading } = this.props;
    const is_mobile = screen_width < 768;
    // const is_tablet = screen_width >= 768 && screen_width <= 1024;
    // log('profile rendered')
    return (
      <Col xs={24} md={6} id="clientProfile" className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10" : "ori-full-parent-height ori-l-border-light ori-overflow-auto"}`}>
        {
          !isEmpty(profile_details) ?
            <ProfileCard
              profile_details={profile_details}
              navigateTo={navigateTo}
              submitCustumAgentNoteForm={this.submitCustumAgentNoteForm}
            />
            :
            <ShowMessage
              img_src={IMG_PERSON}
              title="Customer Profile"
              message="Profile details are not avaliable"
              height={150}
              width={80}
              color='primary'
              show_button={selected_active_chat_id ? true : false}
              button_size="small"
              button_type="primary"
              button_text={loading ? "Loading..." : "Fetch profile"}
              button_loading={loading}
              button_class="ori-lr-pad-15"
              handleButtonClick={this.handleButtonClick}
            />
        }
      </Col>
    );
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    selected_active_chat_id: state.chats_details.selected_active_chat_id,
    selected_active_chat_type: state.chats_details.selected_active_chat_type,
    loading: state.chats_details.loaders.customer_profile_loading,
    profile_details: getClientProfileDetails(state),
    active_chat_session_id: getActiveChatSessionId(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updateCustumAgentNoteFormInChats,
        getJoinedRoomUserProfile
      },
      dispatch),
  };
};

ClientProfile.propTypes = {
  screen_width: PropTypes.number,
  profile_details: PropTypes.object,
  actions: PropTypes.object,
  selected_active_chat_id: PropTypes.string,
  selected_active_chat_type: PropTypes.string,
  active_chat_session_id: PropTypes.string,
  navigateTo: PropTypes.func,
  loading: PropTypes.bool
};

ClientProfile.defaultProps = {
  profile_details: {},
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientProfile);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/components/clientprofile/index.js